"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lifeCycleState = {
    LocationDTO: {
        lifeCycleState: (location, variables, { socket }) => {
            var _a, _b;
            if (!socket) {
                throw new Error('Socket must be passed as context to use lifeCycleState @client directive.');
            }
            if (location && location.gwdid === null) {
                return Promise.resolve(null);
            }
            const gwdid = (_a = location.gwdid) !== null && _a !== void 0 ? _a : variables.gwdid;
            const locationId = (_b = location.locationId) !== null && _b !== void 0 ? _b : variables.locationId;
            if (!gwdid || !locationId) {
                throw new Error('Provide gwdid or locationId either in the location object or as variables.');
            }
            return socket
                .request({
                messageType: 'GetUnitsRequest',
                locationAddress: { resourceType: 'UnitAddress', locationId: locationId, did: gwdid },
            }, 2000)
                .then(r => { var _a, _b, _c, _d; return (_d = (_c = (_b = (_a = r.list) === null || _a === void 0 ? void 0 : _a.find(u => u.chassisDid === gwdid)) === null || _b === void 0 ? void 0 : _b.lifeCycleState) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : null; })
                .catch(() => {
            });
        },
    },
};
exports.default = lifeCycleState;
//# sourceMappingURL=lifeCycleState.js.map